import Vue from 'vue';
import $ from 'jquery';
import 'jquery-ui';
import 'jquery-ui-bundle';
import 'jquery-match-height';
import dayJs from 'dayjs';

Vue.component('date-picker-spa', {

    template: '<div id="spaDatepicker"></div>',
    props: ['dateFormat', 'date', 'validBookingPeriod'],
    data() {
        return {
            spaExceedFuture: "dining-date-exceededFuture",
            endDate: null
        }
    },

    mounted: function () {
        var prv;
        var cur;
        var self = this;
        var monthsToShow = 1;
        if (window.innerWidth > 1200) {
            var monthsToShow = 2;
        }

        this.calculateEndDate()
        this.initialiseFrenchRegion();
        this.initDatePicker(prv, cur, self, monthsToShow)
    },

    beforeDestroy: function () {
        $(this.$el).datepicker('hide').datepicker('destroy');
    },

    methods: {
        sendDate: function () {
            this.$emit(date)
        },

        calculateEndDate: function () {
            const endDate = new Date();

            if (typeof this.validBookingPeriod !== 'undefined' && this.validBookingPeriod !== null) {
                endDate.setDate(endDate.getDate() + parseInt(this.validBookingPeriod, 10));
            } else {
                endDate.setDate(endDate.getDate() + 90)
            }

            this.endDate = endDate
        },

        initialiseFrenchRegion() {
            $.datepicker.regional['fr'] = {
                closeText: "Fermer",
                prevText: "Précédent",
                nextText: "Suivant",
                currentText: "Aujourd'hui",
                monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
                    "juillet", "août", "septembre", "octobre", "novembre", "décembre"],
                monthNamesShort: ["janv.", "févr.", "mars", "avr.", "mai", "juin",
                    "juil.", "août", "sept.", "oct.", "nov.", "déc."],
                dayNames: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
                dayNamesShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
                dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
                weekHeader: "Sem.",
                dateFormat: "dd/mm/yy",
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: ""
            };
        },

        showValidBookingPeriodMessage($elem) {
            $elem.find('.ui-datepicker-header:last').addClass(this.spaExceedFuture).attr('data-validBookingPeriod', window.validSpaBookingPeriod);
        },

        hideValidBookingPeriodMessage($elem) {
            $elem.find('.ui-datepicker-header:last').removeClass(this.spaExceedFuture);
        },

        initDatePicker: function (prv, cur, self, monthsToShow) {

            if (window.preferredCulture == null || window.preferredCulture == '') {
                $.datepicker.setDefaults($.datepicker.regional['en']);
            } else {
                $.datepicker.setDefaults($.datepicker.regional[window.preferredCulture]);
            }


            $(this.$el).datepicker({
                stepMonths: 1,
                minDate: 0,
                firstDay: 1,
                prevText: "Previous month",
                nextText: "Next month",
                dateFormat: this.dateFormat,
                minDate: new Date(),
                maxDate: this.endDate,
                numberOfMonths: this.monthsToShow,

                defaultDate: this.date,

                beforeShowDay: function (date) {
                    return [true, ((date.getTime() >= Math.min(this.prv, this.cur) && date.getTime() <= Math.max(prv, cur)) ? 'ui-individual-date' : '')];
                },

                beforeShowDay: function (date) {
                    return [true, ((date.getTime() >= Math.min(prv, cur) && date.getTime() <= Math.max(prv, cur)) ? 'ui-individual-date' : '')];
                },

                onSelect: function (dateText, inst) {

                    var previousActiveDay = $('#datepicker .ui-state-active');

                    if (previousActiveDay.attr('aria-pressed') != false) {
                        previousActiveDay.attr('aria-pressed', false);
                    }

                    const formattedDate = dayJs(new Date(inst.selectedYear, inst.selectedMonth, parseInt(inst.selectedDay)));
                    const ISOFormat = formattedDate.format();

                    self.$emit('update-date', ISOFormat);

                    var today = new Date();
                    var dd = today.getDate();
                    var mm = today.getMonth() + 1; //January is 0!
                    var yyyy = today.getFullYear();
                    var month;

                    today = yyyy + '-' + mm + '-' + dd;
                    var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
                    var now = new Date();
                    var month = months[now.getMonth()]; // getMonth method returns the month of the date (0-January :: 11-December)
                    today = dd + ' ' + month + ' ' + yyyy;

                    const dateObject = new Date(dateText);
                    const todaysDate = new Date();

                    if (dateObject.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
                        self.$emit('show-cancellation-message', true);
                    }
                    else {
                        self.$emit('show-cancellation-message', false);
                    }

                    setTimeout(function () {
                        var original = $('.date__start-date').html();
                        var result = original.substr(original.indexOf(" ") + 1);

                        if (today === result) {
                            $('.ui-datepicker-today').addClass("ui-datepicker-manual-current-day");
                        }
                        else {
                            $('.ui-datepicker-manual-current-day').removeClass("ui-datepicker-manual-current-day");
                        }
                        var splitDate = dateText.split('-');
                        var formattedDate = splitDate[1] + '/' + splitDate[2] + '/' + splitDate[0];
                        APP.calendarAccessibility.createStatusMessage(formattedDate, null, 'diningreservation-booking__status-message', $('#dining-date').parent());
                        APP.calendarAccessibility.initDateAttributes('spaDatepicker');


                    }, 50);

                },

                onChangeMonthYear: (year, month, inst) => {
                    $("#BookingSpaTabContent .hasDatepicker").removeClass("datepicker-init");
                    setTimeout(() => {

                        if (!this.date) {
                            $("#BookingSpaTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
                        }

                        setTimeout(event => {
                            $("#BookingSpaTabContent .hasDatepicker").addClass("datepicker-init");
                        }, 150);

                        APP.calendarAccessibility.initDateAttributes('spaDatepicker');
                        APP.calendarAccessibility.setTabIndexes('spaDatepicker');

                        if (month === (this.endDate.getMonth() + 1)) {
                            this.showValidBookingPeriodMessage(inst.dpDiv);
                        } else {
                            this.hideValidBookingPeriodMessage(inst.dpDiv);
                        }
                    }, 100);

                    if (!this.date) {
                        $("#spaDatepicker").find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');
                    }


                }
            })
            $(this.$el).datepicker('setDate', null);
            $(this.$el).find('a.ui-state-highlight.ui-state-active').removeClass('ui-state-highlight ui-state-active').parents('.ui-datepicker-current-day').removeClass('ui-datepicker-current-day');

            $("#BookingSpaTabContent .ui-datepicker-current-day").removeClass("ui-datepicker-current-day");
            setTimeout(event => {
                $("#BookingSpaTabContent .hasDatepicker").addClass("datepicker-init");
            }, 150);

            const nextButton = $("#BookingSpaTabContent .ui-datepicker-next");
            const selectBooking = $("#spaDatepicker");
            if (nextButton.hasClass("ui-state-disabled")) {
                self.showValidBookingPeriodMessage(selectBooking)
            }

            APP.calendarAccessibility.initPresentationMode('spaDatepicker');
            APP.calendarAccessibility.initDateAttributes('spaDatepicker');
            APP.calendarAccessibility.initKeyboardNavigation('spaDatepicker');
        }
    }
});